// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-enter-active[data-v-ff8e20a8]{transition-duration:.4s;transition-timing-function:ease}.slide-leave-active[data-v-ff8e20a8]{transition-duration:.4s;transition-timing-function:cubic-bezier(0,1,.5,1)}.slide-enter-to[data-v-ff8e20a8],.slide-leave[data-v-ff8e20a8]{max-height:1000px;overflow:hidden}.slide-enter[data-v-ff8e20a8],.slide-leave-to[data-v-ff8e20a8]{overflow:hidden;max-height:0}", ""]);
// Exports
module.exports = exports;
